/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: queue-detail-grid-component
 *
 * Created by rwilliams on 4/3/17.
 */

function QueueDetailGridController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    ModalService: JS5Object,
) {

    //======//
    // Grid //
    //======//

    const defaultGridColumns = [
        {
            field: 'proxyId',
            enableColumnMenu: false,
            name: 'playIconColumn',
            displayName: '',
            width: 30,
            minWidth: 30,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/play-proxy-icon-template.html'
        },
        {
            field: 'priority',
            enableSorting: false,
            width: 70,
            cellTemplate: 'dashboard/queues/queueDetail/components/cellTemplates/queue-priority-cell-template.html'
        },
        {
            field: 'percentComplete',
            name: 'Progress',
            width: '18%',
            enableSorting: false,
            cellTemplate: 'components/visual/grid/progress-bar-template.html'
        },
        {
            field: 'retries',
            name: 'Retries',
            enableSorting: false,
            width: 65
        },
        {
            field: 'bandwidth',
            name: 'Bandwidth',
            enableSorting: false,
            width: 130,
            cellTemplate: 'dashboard/queues/queueDetail/components/cellTemplates/queue-bandwidth-cell-template.html'
        },
        {
            field: 'eTA',
            name: 'ETA',
            displayName: 'ETA',
            enableSorting: false,
            minWidth: 195,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\''
        },
        {
            field: 'categoryTypeName',
            name: 'Category Type',
            enableSorting: false,
            width: 130
        },
        {
            field: 'networkName',
            name: 'Network',
            enableSorting: false,
            width: 140
        },
        {
            field: 'contentName',
            name: 'Series/Movie/Ad',
            enableSorting: false,
            width: 140
        },
        {
            field: 'title',
            name: 'Title',
            enableSorting: false,
            width: 200
        },
        {
            field: 'originalReleaseDate',
            name: 'Original Release Date',
            enableSorting: false,
            width: 160,
            cellFilter: 'date:\'MM/dd/yyyy\''
        },
        {
            field: 'airTime',
            name: 'Air Time',
            enableSorting: false,
            width: 100,
            cellFilter: 'date:\'hh:mm\''
        },
        {
            field: 'categoryName',
            name: 'Category',
            enableSorting: false,
            width: 100
        },
        {
            field: 'partnerName',
            name: 'Partner',
            enableSorting: false,
            width: 100
        },
        {
            field: 'creationTime',
            name: 'Creation Time',
            enableSorting: false,
            minWidth: 195,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\''
        },
        {
            field: 'startTime',
            name: 'Start Time',
            enableSorting: false,
            width: 195,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\''
        },
        {
            field: 'endTime',
            name: 'Complete Time',
            enableSorting: false,
            cellFilter: 'date:\'MM/dd/yyyy hh:mm:ss a\'',
            minWidth: 195
        }
    ];

    this.gridOptions = {
        appScopeProvider: this,
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: 1,
        enableVerticalScrollbar: 2,
        multiSelect: true,
        rowTemplate: 'dashboard/queues/queueDetail/components/cellTemplates/queue-step-row-template.html',
        isRowSelectable: (row: JS5Object) => {
            return this.canEditPriority({queueStep: row.entity});
        },
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        }
    };

    const updateExcludedColumns = () => {
        let excludedColumns = _.uniq(this.excludedColumns);
        let newColumnDefs = _.clone(defaultGridColumns);
        _.remove(newColumnDefs, (colDef: JS5Object) => {
            return _.includes(excludedColumns, colDef.field);
        });
        this.gridOptions.columnDefs = newColumnDefs;
    };

    const buildGridData = (activeSteps: JS5Object[], queuedSteps: JS5Object[]) => {
        let activeHeader = { header: true, title: 'Active', style: 'active-queue-header' };
        let queuedHeader = { header: true, title: 'Queued', style: 'queued-queue-header' };
        let noneRow = { header: true, title: 'None', style: 'blank-queue-header' };

        if (activeSteps.length === this.pagingOptions.pageSize) {
            return _.concat([], activeHeader, activeSteps);
        } else if (this.pagingOptions.currentPage === 1) {
            return _.concat([], activeHeader, (activeSteps.length > 0) ? activeSteps : noneRow, queuedHeader, (queuedSteps.length > 0) ? queuedSteps : noneRow);
        } else if (activeSteps.length === 0) {
            return _.concat([], queuedHeader, queuedSteps);
        } else {
            return _.concat([], activeHeader, (activeSteps.length > 0) ? activeSteps : noneRow, queuedHeader, (queuedSteps.length > 0) ? queuedSteps : noneRow);
        }
    };

    const updateGridData = () => {
        let prevSelectedStepIds: JS5Object = {};
        if (this.gridApi) {
            _.forEach(this.gridApi.selection.getSelectedRows(), (queueStep: JS5Object) => {
                prevSelectedStepIds[queueStep.id] = true;
            });
            this.gridApi.selection.clearSelectedRows();
        }

        if (this.statusName === 'active') {
            let sortedSteps = _.partition(this.queueSteps, function(step: JS5Object) {
                return step.status === 'EXECUTING';
            });
            let activeSteps = sortedSteps[0];
            let queuedSteps = sortedSteps[1];
            this.gridOptions.data = buildGridData(activeSteps, queuedSteps);

        } else {
            this.gridOptions.data = this.queueSteps;
        }

        if (_.size(prevSelectedStepIds) > 0) {
            $timeout(() => {
                _.forEach(this.gridOptions.data, (queueStep: JS5Object) => {
                    if (this.canEditPriority({queueStep: queueStep}) &&
                        prevSelectedStepIds[queueStep.id]) {
                        this.gridApi.selection.selectRow(queueStep);
                    }
                });
            });
        }
    };

    const invokeOnStepPrioritiesChanged = (modifiedQueueSteps: JS5Object[]) => {
        this.gridApi.selection.clearSelectedRows();
        this.onStepPrioritiesChanged({
            modifiedQueueSteps: modifiedQueueSteps
        });
    };

    this.onRowDoubleClicked = (row: JS5Object) => {
        if (this.canEditPriority({queueStep: row.entity})) {
            this.gridApi.selection.selectRow(row.entity);
            let queueSteps = this.gridApi.selection.getSelectedRows();
            ModalService.showQueuePriorityEditorModal(
                queueSteps,
                invokeOnStepPrioritiesChanged
            );
        }
    };

    this.openVideoModal = (media: JS5Object) => {
        if (this.canOpenVideoModel({media: media})) {
            ModalService.showMediaModal('video', media, media.proxyId);
        }
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onChanges = (changes: JS5Object) => {
        if (changes.excludedColumns) {
            updateExcludedColumns();
        }
        if (changes.queueSteps) {
            updateGridData();
        }
    };

    this.$onInit = () => {
        updateExcludedColumns();
        updateGridData();
    };
}

angular.module('prism-ui.queues').component('queueDetailGrid', {
	bindings: {
        canOpenVideoModel: '&',
	    canEditPriority: '&',
        onStepPrioritiesChanged: '&',
	    excludedColumns: '<',
        pagingOptions: '=',
	    queueSteps: '<',
		statusName: '@'
	},
    controller: QueueDetailGridController,
	templateUrl: 'dashboard/queues/queueDetail/components/queue-detail-grid-template.html'
});
